import { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  CircularProgress,
  Grid,
  InputLabel,
  FormControl,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Select from "@mui/material/Select";
import { post, put } from "src/utils/networkUtils";
import useTenantCompetitions from "src/hooks/useTenantCompetitions";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

const dateFormat = "YYYY-MM-DD HH:mm:ss";
const defaultStagePeriod = {
  startDate: moment().format(dateFormat),
  endDate: moment().format(dateFormat),
  breakdown: "1=1000,2=700,3=500,4=400,5=300,6-10=200,11-30=150,31-100=100",
  isCompleted: false,
  prizePool: "",
  name: "",
  description: "",
};
export default function StagePeriodDialog(props) {
  const [stagePeriod, setStagePeriod] = useState(null);
  const [loading, setLoading] = useState(false);

  // Use the hook to get tenant competitions
  const { tenantCompetitions } = useTenantCompetitions(props.tenantId);

  useEffect(() => {
    if (props?.stagePeriod) {
      setStagePeriod(props.stagePeriod);
    } else {
      setStagePeriod(defaultStagePeriod);
    }

    // Set default competition if tenant competitions are available
    if (tenantCompetitions.length > 0) {
      setStagePeriod((prevState) => ({
        ...prevState,
        competitionId: tenantCompetitions[0].competitionId,
      }));
    }
  }, [props.stagePeriod, tenantCompetitions]);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setStagePeriod((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    setLoading(true);
    stagePeriod.tenantId = parseInt(props.tenantId) || 1;
    if (props?.stagePeriod) {
      put(
        `/admin/stage-periods/${stagePeriod.stagePeriodId}?tenantId=${props.tenantId}`,
        stagePeriod
      ).then(function (response) {
        props.onSuccessHandler();
      });
    } else {
      post(`/admin/stage-periods?tenantId=${props.tenantId}`, stagePeriod).then(function (response) {
        props.onSuccessHandler();
      });
    }
  };
  const onCancel = () => {
    props.onClose();
  };

  const handleDateChange = (newValue, fieldName) => {
    console.log(newValue, moment(newValue).format(dateFormat));
    setStagePeriod((prevState) => ({
      ...prevState,
      [fieldName]: moment(newValue).seconds(0).format(dateFormat),
    }));
  };
  const handleCompetitionIdChange = (value) => {
    setStagePeriod((prevState) => ({
      ...prevState,
      competitionId: value,
    }));
  };
  const handleChangeCompleted = (e) => {
    setStagePeriod((prevState) => ({
      ...prevState,
      isCompleted: e.target.checked,
    }));
  };
  const handleChangeVisible = (e) => {
    setStagePeriod((prevState) => ({
      ...prevState,
      isVisible: e.target.checked,
    }));
  };
  console.log("stagePeriod edit", stagePeriod);
  return (
    <Dialog
      open={props.open}
      onClose={() => { }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Stage Period</DialogTitle>
      <DialogContent>
        {stagePeriod === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container>
            <Grid item xs={6} sx={{ m: 0, p: 1 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="Start Date"
                  value={moment(stagePeriod.startDate, dateFormat)}
                  onChange={(value) => handleDateChange(value, "startDate")}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} sx={{ m: 0, p: 1 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="End Date"
                  value={moment(stagePeriod.endDate, dateFormat)}
                  onChange={(value) => handleDateChange(value, "endDate")}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            {/**
             * <Grid item xs={4} sx={{ m: 0, p: 1 }}>
              <TextField
                id="prizePool"
                label="Prize Pool"
                fullWidth
                value={stagePeriod.prizePool}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
             */}
            <Grid item xs={8} sx={{ m: 0, p: 1 }}>
              <TextField
                id="name"
                label="Name"
                fullWidth
                value={stagePeriod.name}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4} sx={{ m: 0, p: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={stagePeriod.isVisible}
                    onChange={handleChangeVisible}
                    id="isVisible"
                  />
                }
                label="Visible"
              />
            </Grid>
            <Grid item xs={12} sx={{ m: 0, p: 1 }}>
              <TextField
                id="description"
                label="Description"
                fullWidth
                value={stagePeriod.description}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sx={{ m: 0, p: 1 }}>
              <TextField
                id="breakdown"
                label="Breakdown"
                fullWidth
                value={stagePeriod.breakdown}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            {/**
             * <Grid item xs={4} sx={{ m: 0, p: 1 }}>
              <TextField
                id="customPrizePool"
                label="Custom Prize Pool"
                fullWidth
                value={stagePeriod.customPrizePool}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>*/}
            <Grid item xs={12} sx={{ m: 0, p: 1 }}>
              <TextField
                id="customPrizeBreakdown"
                label="Custom Prize Breakdown"
                fullWidth
                value={stagePeriod.customPrizeBreakdown}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={4} sx={{ m: 0, p: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={stagePeriod.isCompleted}
                    onChange={handleChangeCompleted}
                    id="isCompleted"
                  />
                }
                label="Completed"
              />
            </Grid>
            <Grid item xs={4} sx={{ m: 0, p: 1 }}>
              <TextField
                id="entryFee"
                label="Entry Fee Coins"
                fullWidth
                value={stagePeriod.entryFee}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4} sx={{ m: 0, p: 1 }}>
              <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                <InputLabel id="demo-simple-select-label">
                  Competition
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={stagePeriod.competitionId ?? ""}
                  label="Competition"
                  onChange={(event) =>
                    handleCompetitionIdChange(event.target.value)
                  }
                >
                  {tenantCompetitions.length > 0 &&
                    tenantCompetitions.map((tenantCompetition) => (
                      <MenuItem
                        value={tenantCompetition.competitionId}
                        key={`competition-${tenantCompetition.competitionId}`}
                      >
                        {tenantCompetition.competitionName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button onClick={() => onSuccess()} autoFocus disabled={false}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
